export default "__VITE_ASSET__2Zt99Svm__"